import { ILoggerProgram } from '@models/ILoggerProgram';
import { DaysOfWeek } from '@models/DaysOfWeek';
import { addMinutes, startOfToday, addDays } from 'date-fns';

export const loggerProgrammingDefaultStartTimeDate = () => {
  const date = new Date();
  const startOfTodayDate = addMinutes(startOfToday(), -date.getTimezoneOffset());

  if (date.getTime() > addMinutes(startOfTodayDate, 90).getTime()) {
    const nextDayDate = addDays(startOfTodayDate, 1);
    return addMinutes(nextDayDate, 90);
  }
  return addMinutes(startOfTodayDate, 90);
};

export const defaultValues: ILoggerProgram = {
  id: null,
  siteName: '',
  address: '',
  smsNumber: '',
  serialNumber: '',
  minutesBeetweenRecordings: 5,
  numberOfSoundRecordings: 1,
  lenghtOfRecording: 10,
  whenInLeakRepeatRecordingsForDays: 0,
  repeatRecordingsForDays: 1,
  startTime: loggerProgrammingDefaultStartTimeDate(),
  daysToRecord: new DaysOfWeek(),
  whenInLeakMode: 'RecordEveryNumberOfDays',
  soundRecordingMode: 'AtPresetTime',
};
